import React, { PureComponent } from "react";
import _ from "lodash";

import { Translate } from "react-redux-i18n";

import {
  roundToDecimals,
  momentModule,
  parseAddress,
  isValidDurationCdr,
} from "../../utils/Utils";

import "../../../styles/components/insights/reports/Report.scss";
import evio from "../../../styles/images/evio.svg";
import calendar from "../../../styles/images/calendar.svg";
import battery from "../../../styles/images/battery_darkgrey.svg";
import co2 from "../../../styles/images/co2.svg";
import energy from "../../../styles/images/energy_darkgrey.svg";
import clock from "../../../styles/images/clock_darkgrey.svg";
import money from "../../../styles/images/money_darkgrey.svg";

const { moment, formatDate } = momentModule;

class Report extends PureComponent {
  componentDidUpdate(prevProps, prevState) {
    if (this.props.groupBy === "ev_history") {
      const style = document.createElement("style");
      style.innerHTML = `@page {size: 297mm 210mm}`;
      style.id = "page-orientation";
      document.head.appendChild(style);
    }
  }

  renderTitle() {
    switch (this.props.groupBy) {
      case "card":
      case "ev":
      case "network":
      case "fleet": {
        return (
          <div className="title">
            <Translate value="report_evMonthlyReport" />
            <span>-</span>
            <Translate
              value={`report_groupedBy${_.capitalize(this.props.groupBy)}`}
            />
          </div>
        );
      }
      case "user": {
        return (
          <div className="title">
            {this.props.mode === "evs" ? (
              <Translate value="report_evMonthlyReport" />
            ) : (
              <Translate value="report_chargerMonthlyReport" />
            )}
            <span>-</span>
            <Translate
              value={`report_groupedBy${_.capitalize(this.props.groupBy)}`}
            />
          </div>
        );
      }
      case "infrastructure":
      case "charger": {
        return (
          <div className="title">
            <Translate value="report_chargerMonthlyReport" />
            <span>-</span>
            <Translate
              value={`report_groupedBy${_.capitalize(this.props.groupBy)}`}
            />
          </div>
        );
      }
      case "ev_history": {
        return (
          <div className="title">
            <Translate value="report_evHistory" />
          </div>
        );
      }
      case "charger_history": {
        return (
          <div className="title">
            <Translate value="report_chargerHistory" />
          </div>
        );
      }
      default:
    }
  }

  renderTotalKPIs() {
    switch (this.props.groupBy) {
      case "card":
      case "user":
      case "ev":
      case "network":
      case "fleet":
      case "infrastructure":
      case "charger": {
        return (
          <>
            <div className="kpi">
              <img src={battery} alt="" />
              <Translate value="report_sessions" />
              <p>{this.props.data.totals?.totalSessions ?? "-"}</p>
            </div>
            <div className="kpi">
              <img src={co2} alt="" />
              <Translate value="report_co2Saved" />
              <p>
                {roundToDecimals(this.props.data.totals?.totalCO2Saved, 3) ??
                  "-"}{" "}
                g
              </p>
            </div>
            <div className="kpi">
              <img src={energy} alt="" />
              <Translate value="report_energy" />
              <p>
                {roundToDecimals(
                  this.props.data.totals?.totalPower / 1000,
                  3
                ) ?? "-"}{" "}
                kWh
              </p>
            </div>
            <div className="kpi">
              <img src={clock} alt="" />
              <Translate value="report_chargingTime" />
              <p>
                {moment
                  .duration(this.props.data.totals?.timeCharged, "seconds")
                  .format("h[h] m[m] s[s]")}
              </p>
            </div>
            {(this.props.groupBy === "infrastructure" ||
              this.props.groupBy === "charger" ||
              (this.props.groupBy === "user" &&
                this.props.mode === "chargers")) && (
              <div className="kpi">
                <img src={money} alt="" />
                <Translate value="report_costNoVat" />
                <p>
                  {roundToDecimals(
                    this.props.data.totals?.purchaseTariffDetailsExclVat,
                    2
                  ) ?? "-"}{" "}
                  €
                </p>
              </div>
            )}
            <div className="kpi">
              <img src={money} alt="" />
              <Translate
                value={`report_${
                  this.props.groupBy === "infrastructure" ||
                  this.props.groupBy === "charger" ||
                  (this.props.groupBy === "user" &&
                    this.props.mode === "chargers")
                    ? "revenue"
                    : "cost"
                }NoVat`}
              />
              <p>
                {roundToDecimals(
                  this.props.data.totals?.totalPriceExclVat,
                  2
                ) ?? "-"}{" "}
                €
              </p>
            </div>
          </>
        );
      }
      case "ev_history":
      case "charger_history": {
        return (
          <>
            <div className="kpi">
              <img src={battery} alt="" />
              <Translate value="report_sessions" />
              <p>{this.props.data.groupedBy.totalSessions}</p>
            </div>
            <div className="kpi">
              <img src={co2} alt="" />
              <Translate value="report_co2Saved" />
              <p>
                {roundToDecimals(this.props.data.groupedBy.totalCO2Emitted, 3)}{" "}
                g
              </p>
            </div>
            <div className="kpi">
              <img src={energy} alt="" />
              <Translate value="report_energy" />
              <p>
                {roundToDecimals(this.props.data.groupedBy.totalEnergy, 3)} kWh
              </p>
            </div>
            <div className="kpi">
              <img src={clock} alt="" />
              <Translate value="report_chargingTime" />
              <p>
                {moment
                  .duration(
                    this.props.data.groupedBy.totalChargingTime,
                    "hours"
                  )
                  .format("h[h] m[m] s[s]")}
              </p>
            </div>
            {this.props.groupBy === "charger_history" && (
              <div className="kpi">
                <img src={money} alt="" />
                <Translate
                  value={`report_cost${this.props.withVat ? "Vat" : "NoVat"}`}
                />
                <p>
                  {roundToDecimals(this.props.data.groupedBy.totalCost, 2)} €
                </p>
              </div>
            )}
            <div className="kpi">
              <img src={money} alt="" />
              <Translate
                value={`report_${
                  this.props.groupBy === "ev_history" ? "cost" : "revenue"
                }${this.props.withVat ? "Vat" : "NoVat"}`}
              />
              <p>{roundToDecimals(this.props.data.groupedBy.totalCost, 2)} €</p>
            </div>
          </>
        );
      }
      default:
    }
  }

  renderGroupKPIs() {
    return this.props.data.totalsGroupBy.map((kpi, idx) => {
      return (
        <div key={idx} className="bordered group-kpis">
          {this.props.groupBy === "charger" ? (
            <div className="kpis-header">
              <p>
                <Translate value={`report_${this.props.groupBy}`} />
                <span>{kpi.name}</span>
              </p>
              <p>
                <Translate value="report_location" />
                <span>{parseAddress(kpi.address)}</span>
              </p>
            </div>
          ) : (
            <p>
              <Translate value={`report_${this.props.groupBy}`} />
              <span>
                {this.props.groupBy === "ev" ? (
                  kpi.licensePlate ?? <Translate value="report_anonymous" />
                ) : this.props.groupBy === "network" ? (
                  kpi.network
                ) : kpi.name === "history_public" ? (
                  <Translate value={kpi.name} />
                ) : (
                  kpi.name
                )}
              </span>
            </p>
          )}
          <div className="kpis-container">
            <div className="kpi">
              <img src={battery} alt="" />
              <Translate value="report_sessions" />
              <p>{kpi.totalSessions}</p>
            </div>
            <div className="kpi">
              <img src={co2} alt="" />
              <Translate value="report_co2Saved" />
              <p>
                {kpi.totalCO2Saved !== undefined &&
                !Number.isNaN(parseFloat(kpi.totalCO2Saved))
                  ? roundToDecimals(kpi.totalCO2Saved, 3)
                  : "-"}
                g
              </p>
            </div>
            <div className="kpi">
              <img src={energy} alt="" />
              <Translate value="report_energy" />
              <p>
                {kpi.totalPower !== undefined && !Number.isNaN(kpi.totalPower)
                  ? roundToDecimals(kpi.totalPower / 1000, 3)
                  : "-"}
                kWh
              </p>
            </div>
            <div className="kpi">
              <img src={clock} alt="" />
              <Translate value="report_chargingTime" />
              <p>
                {moment
                  .duration(kpi.timeCharged, "seconds")
                  .format("h[h] m[m] s[s]")}
              </p>
            </div>
            {(this.props.groupBy === "infrastructure" ||
              this.props.groupBy === "charger" ||
              (this.props.groupBy === "user" &&
                this.props.mode === "chargers")) && (
              <div className="kpi">
                <img src={money} alt="" />
                <Translate
                  value={`report_cost${this.props.withVat ? "Vat" : "NoVat"}`}
                />
                <p>{roundToDecimals(kpi.purchaseTariffDetailsExclVat, 2)} €</p>
              </div>
            )}
            <div className="kpi">
              <img src={money} alt="" />
              <Translate
                value={`report_${
                  this.props.groupBy === "infrastructure" ||
                  this.props.groupBy === "charger" ||
                  (this.props.groupBy === "user" &&
                    this.props.mode === "chargers")
                    ? "revenue"
                    : "cost"
                }${this.props.withVat ? "Vat" : "NoVat"}`}
              />
              <p>{roundToDecimals(kpi.totalPriceExclVat, 2)} €</p>
            </div>
          </div>
        </div>
      );
    });
  }

  renderTableKPIs() {
    if (this.props.groupBy === "user") {
      return this.props.data.totalsGroupBy.map((kpi) => {
        return (
          <div className="kpi-table-container">
            <div key={kpi.name} className="group-kpis">
              <p>
                <Translate value={`report_${this.props.groupBy}`} />
                <span>
                  {kpi.name === "history_public" ? (
                    <Translate value={kpi.name} />
                  ) : (
                    kpi.name
                  )}
                </span>
              </p>
              <div className="kpis-container">
                <div className="kpi">
                  <img src={battery} alt="" />
                  <Translate value="report_sessions" />
                  <p>{kpi.totalSessions}</p>
                </div>
                <div className="kpi">
                  <img src={co2} alt="" />
                  <Translate value="report_co2Saved" />
                  <p>
                    {kpi.totalCO2Saved !== undefined &&
                    !Number.isNaN(kpi.totalCO2Saved)
                      ? roundToDecimals(kpi.totalCO2Saved, 3)
                      : "-"}
                    g
                  </p>
                </div>
                <div className="kpi">
                  <img src={energy} alt="" />
                  <Translate value="report_energy" />
                  <p>
                    {kpi.totalPower !== undefined &&
                    !Number.isNaN(kpi.totalPower)
                      ? roundToDecimals(kpi.totalPower / 1000, 3)
                      : "-"}
                    kWh
                  </p>
                </div>
                <div className="kpi">
                  <img src={clock} alt="" />
                  <Translate value="report_chargingTime" />
                  <p>
                    {moment
                      .duration(kpi.timeCharged, "seconds")
                      .format("h[h] m[m] s[s]")}
                  </p>
                </div>
                {this.props.mode === "evs" ? (
                  <div className="kpi">
                    <img src={money} alt="" />
                    <Translate value="report_costNoVat" />
                    <p>{roundToDecimals(kpi.totalPriceExclVat, 2)} €</p>
                  </div>
                ) : (
                  <>
                    <div className="kpi">
                      <img src={money} alt="" />
                      <Translate value="report_costNoVat" />
                      <p>
                        {roundToDecimals(kpi.purchaseTariffDetailsExclVat, 2)} €
                      </p>
                    </div>
                    <div className="kpi">
                      <img src={money} alt="" />
                      <Translate value="report_revenueNoVat" />
                      <p>{roundToDecimals(kpi.totalPriceExclVat, 2)} €</p>
                    </div>
                  </>
                )}
              </div>
            </div>
            <table className="table table-sm">
              <thead className="table-header">
                <tr className="row no-gutters">
                  <th className="col title">
                    <Translate value="report_date" />
                  </th>
                  <th className="col title">
                    <Translate value="report_duration" />
                  </th>
                  <th className="col title">
                    <Translate value="report_EV" />
                  </th>
                  <th className="col title">
                    <Translate value="report_charger" />
                  </th>
                  <th className="col title">
                    <Translate value="report_energy" />
                  </th>
                  <th className="col title">
                    <Translate value="report_user" />
                  </th>
                  <th className="col title">
                    <Translate value="report_network" />
                  </th>
                  <th className="col title">
                    <Translate value="report_location" />
                  </th>
                  <th className="col title">
                    <Translate value="report_costNoVat" />
                  </th>
                  {this.props.mode === "chargers" && (
                    <th className="col title">
                      <Translate value="report_revenueNoVat" />
                    </th>
                  )}
                </tr>
              </thead>
              <tbody className="table-values">
                {kpi.list.map((s) => {
                  return (
                    <tr className="row no-gutters">
                      <td className="col">
                        {formatDate(s.startDate, "datetime")}
                      </td>
                      <td className="col">
                        {isValidDurationCdr(s, "seconds")
                          ? "-"
                          : moment
                              .duration(s.timeCharged, "seconds")
                              .format("h[h] m[m] s[s]")}
                      </td>
                      <td className="col">{s.ev?.licensePlate || "-"}</td>
                      <td className="col">{s.charger?.hwId || "-"}</td>
                      <td className="col">{`${roundToDecimals(
                        s.totalPower / 1000,
                        3
                      )} kWh`}</td>
                      <td className="col">{s.user?.name || "-"}</td>
                      <td className="col">{s.network || "-"}</td>
                      <td className="col">
                        {parseAddress(s.charger?.address)}
                      </td>
                      {this.props.mode === "evs" ? (
                        <td className="col">
                          {isValidDurationCdr(s, "seconds")
                            ? "-"
                            : `${roundToDecimals(s.totalPrice?.excl_vat, 2)}€`}
                        </td>
                      ) : (
                        <>
                          <td className="col">{`${roundToDecimals(
                            s.purchaseTariffDetails?.excl_vat,
                            2
                          )}€`}</td>
                          <td className="col">
                            {`${roundToDecimals(s.totalPrice?.excl_vat, 2)}€`}
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      });
    } else if (this.props.groupBy === "ev") {
      return this.props.data.totalsGroupBy.map((ev, idx) => {
        return (
          <div className="kpi-table-container">
            <div className="group-kpis">
              <p>
                <Translate value={`report_${this.props.groupBy}`} />
                {ev.licensePlate ? (
                  <span>{ev.licensePlate}</span>
                ) : (
                  <Translate value="report_anonymous" />
                )}
              </p>
              <div className="kpis-container">
                <div className="kpi">
                  <img src={battery} alt="" />
                  <Translate value="report_sessions" />
                  <p>{ev.totalSessions}</p>
                </div>
                <div className="kpi">
                  <img src={co2} alt="" />
                  <Translate value="report_co2Saved" />
                  <p>
                    {ev.totalCO2Saved !== undefined &&
                    !Number.isNaN(ev.totalCO2Saved)
                      ? roundToDecimals(ev.totalCO2Saved, 3)
                      : "-"}
                    g
                  </p>
                </div>
                <div className="kpi">
                  <img src={energy} alt="" />
                  <Translate value="report_energy" />
                  <p>
                    {ev.totalPower !== undefined && !Number.isNaN(ev.totalPower)
                      ? roundToDecimals(ev.totalPower / 1000, 3)
                      : "-"}
                    kWh
                  </p>
                </div>
                <div className="kpi">
                  <img src={clock} alt="" />
                  <Translate value="report_chargingTime" />
                  <p>
                    {moment
                      .duration(ev.timeCharged, "seconds")
                      .format("h[h] m[m] s[s]")}
                  </p>
                </div>
                <div className="kpi">
                  <img src={money} alt="" />
                  <Translate value="report_costNoVat" />
                  <p>{roundToDecimals(ev.totalPriceExclVat, 2)} €</p>
                </div>
              </div>
            </div>
            <table className="table table-sm">
              <thead className="table-header">
                <tr className="row no-gutters">
                  <th className="col title">
                    <Translate value="report_date" />
                  </th>
                  <th className="col title">
                    <Translate value="report_duration" />
                  </th>
                  <th className="col title">
                    <Translate value="report_EV" />
                  </th>
                  <th className="col title">
                    <Translate value="report_charger" />
                  </th>
                  <th className="col title">
                    <Translate value="report_energy" />
                  </th>
                  <th className="col title">
                    <Translate value="report_user" />
                  </th>
                  <th className="col title">
                    <Translate value="report_network" />
                  </th>
                  <th className="col title">
                    <Translate value="report_location" />
                  </th>
                  <th className="col title">
                    <Translate value="report_costNoVat" />
                  </th>
                </tr>
              </thead>
              <tbody className="table-values">
                {ev.list.map((s) => {
                  return (
                    <tr className="row no-gutters">
                      <td className="col">
                        {formatDate(s.startDate, "datetime")}
                      </td>
                      <td className="col">
                        {isValidDurationCdr(s, "seconds")
                          ? "-"
                          : moment
                              .duration(s.timeCharged, "seconds")
                              .format("h[h] m[m] s[s]")}
                      </td>
                      <td className="col">{s.ev?.licensePlate || "-"}</td>
                      <td className="col">{s.charger?.hwId || "-"}</td>
                      <td className="col">{`${roundToDecimals(
                        s.totalPower / 1000,
                        3
                      )} kWh`}</td>
                      <td className="col">{s.user?.name || "-"}</td>
                      <td className="col">{s.network || "-"}</td>
                      <td className="col">
                        {parseAddress(s.charger?.address)}
                      </td>
                      <td className="col">
                        {isValidDurationCdr(s, "seconds")
                          ? "-"
                          : `${roundToDecimals(s.totalPrice?.excl_vat, 2)}€`}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      });
    } else if (this.props.groupBy === "network") {
      return this.props.data.totalsGroupBy.map((kpi) => {
        return (
          <div className="kpi-table-container">
            <div key={kpi.network} className="group-kpis">
              <p>
                <Translate value={`report_${this.props.groupBy}`} />
                <span>{kpi.network}</span>
              </p>
              <div className="kpis-container">
                <div className="kpi">
                  <img src={battery} alt="" />
                  <Translate value="report_sessions" />
                  <p>{kpi.totalSessions}</p>
                </div>
                <div className="kpi">
                  <img src={co2} alt="" />
                  <Translate value="report_co2Saved" />
                  <p>
                    {kpi.totalCO2Saved !== undefined &&
                    !Number.isNaN(kpi.totalCO2Saved)
                      ? roundToDecimals(kpi.totalCO2Saved, 3)
                      : "-"}
                    g
                  </p>
                </div>
                <div className="kpi">
                  <img src={energy} alt="" />
                  <Translate value="report_energy" />
                  <p>
                    {kpi.totalPower !== undefined &&
                    !Number.isNaN(kpi.totalPower)
                      ? roundToDecimals(kpi.totalPower / 1000, 3)
                      : "-"}
                    kWh
                  </p>
                </div>
                <div className="kpi">
                  <img src={clock} alt="" />
                  <Translate value="report_chargingTime" />
                  <p>
                    {moment
                      .duration(kpi.timeCharged, "seconds")
                      .format("h[h] m[m] s[s]")}
                  </p>
                </div>
                <div className="kpi">
                  <img src={money} alt="" />
                  <Translate value="report_costNoVat" />
                  <p>{roundToDecimals(kpi.totalPriceExclVat, 2)} €</p>
                </div>
              </div>
            </div>
            <table className="table table-sm">
              <thead className="table-header">
                <tr className="row no-gutters">
                  <th className="col title">
                    <Translate value="report_date" />
                  </th>
                  <th className="col title">
                    <Translate value="report_duration" />
                  </th>
                  <th className="col title">
                    <Translate value="report_EV" />
                  </th>
                  <th className="col title">
                    <Translate value="report_charger" />
                  </th>
                  <th className="col title">
                    <Translate value="report_energy" />
                  </th>
                  <th className="col title">
                    <Translate value="report_user" />
                  </th>
                  <th className="col title">
                    <Translate value="report_network" />
                  </th>
                  <th className="col title">
                    <Translate value="report_location" />
                  </th>
                  <th className="col title">
                    <Translate value="report_costNoVat" />
                  </th>
                </tr>
              </thead>
              <tbody className="table-values">
                {kpi.list.map((s) => {
                  return (
                    <tr className="row no-gutters">
                      <td className="col">
                        {formatDate(s.startDate, "datetime")}
                      </td>
                      <td className="col">
                        {isValidDurationCdr(s, "seconds")
                          ? "-"
                          : moment
                              .duration(s.timeCharged, "seconds")
                              .format("h[h] m[m] s[s]")}
                      </td>
                      <td className="col">{s.ev?.licensePlate || "-"}</td>
                      <td className="col">{s.charger?.hwId || "-"}</td>
                      <td className="col">{`${roundToDecimals(
                        s.totalPower / 1000,
                        3
                      )} kWh`}</td>
                      <td className="col">{s.user?.name || "-"}</td>
                      <td className="col">{s.network || "-"}</td>
                      <td className="col">
                        {parseAddress(s.charger?.address)}
                      </td>
                      <td className="col">
                        {isValidDurationCdr(s, "seconds")
                          ? "-"
                          : `${roundToDecimals(s.totalPrice?.excl_vat, 2)}€`}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      });
    } else if (this.props.groupBy === "infrastructure") {
      return this.props.data.totalsGroupBy.map((kpi) => {
        return (
          <div className="kpi-table-container">
            <div key={kpi.name} className="group-kpis">
              <p>
                <Translate value={`report_${this.props.groupBy}`} />
                <span>{kpi.name}</span>
              </p>
              <div className="kpis-container">
                <div className="kpi">
                  <img src={battery} alt="" />
                  <Translate value="report_sessions" />
                  <p>{kpi.totalSessions}</p>
                </div>
                <div className="kpi">
                  <img src={co2} alt="" />
                  <Translate value="report_co2Saved" />
                  <p>
                    {kpi.totalCO2Saved !== undefined &&
                    !Number.isNaN(kpi.totalCO2Saved)
                      ? roundToDecimals(kpi.totalCO2Saved, 3)
                      : "-"}
                    g
                  </p>
                </div>
                <div className="kpi">
                  <img src={energy} alt="" />
                  <Translate value="report_energy" />
                  <p>
                    {kpi.totalPower !== undefined &&
                    !Number.isNaN(kpi.totalPower)
                      ? roundToDecimals(kpi.totalPower / 1000, 3)
                      : "-"}
                    kWh
                  </p>
                </div>
                <div className="kpi">
                  <img src={clock} alt="" />
                  <Translate value="report_chargingTime" />
                  <p>
                    {moment
                      .duration(kpi.timeCharged, "seconds")
                      .format("h[h] m[m] s[s]")}
                  </p>
                </div>
                <div className="kpi">
                  <img src={money} alt="" />
                  <Translate value="report_costNoVat" />
                  <p>
                    {roundToDecimals(kpi.purchaseTariffDetailsExclVat, 2)} €
                  </p>
                </div>
                <div className="kpi">
                  <img src={money} alt="" />
                  <Translate value="report_revenueNoVat" />
                  <p>{roundToDecimals(kpi.totalPriceExclVat, 2)} €</p>
                </div>
              </div>
            </div>
            <table className="table table-sm">
              <thead className="table-header">
                <tr className="row no-gutters">
                  <th className="col title">
                    <Translate value="report_date" />
                  </th>
                  <th className="col title">
                    <Translate value="report_duration" />
                  </th>
                  <th className="col title">
                    <Translate value="report_charger" />
                  </th>
                  <th className="col title">
                    <Translate value="report_location" />
                  </th>
                  <th className="col title">
                    <Translate value="report_energy" />
                  </th>
                  <th className="col title">
                    <Translate value="report_ev" />
                  </th>
                  <th className="col title">
                    <Translate value="report_user" />
                  </th>
                  <th className="col title">
                    <Translate value="report_network" />
                  </th>
                  <th className="col title">
                    <Translate value="report_costNoVat" />
                  </th>
                  <th className="col title">
                    <Translate value="report_revenueNoVat" />
                  </th>
                </tr>
              </thead>
              <tbody className="table-values">
                {kpi.list.map((s) => {
                  return (
                    <tr className="row no-gutters">
                      <td className="col">
                        {formatDate(s.startDate, "datetime")}
                      </td>
                      <td className="col">
                        {moment
                          .duration(s.timeCharged, "seconds")
                          .format("h[h] m[m] s[s]")}
                      </td>
                      <td className="col">{s.charger?.name || "-"}</td>
                      <td className="col">
                        {parseAddress(s.charger?.address)}
                      </td>
                      <td className="col">{`${roundToDecimals(
                        s.totalPower / 1000,
                        3
                      )} kWh`}</td>
                      <td className="col">{s.ev?.licensePlate || "-"}</td>
                      <td className="col">{s.user?.name || "-"}</td>
                      <td className="col">{s.network || "-"}</td>
                      <td className="col">{`${roundToDecimals(
                        s.purchaseTariffDetails?.excl_vat,
                        2
                      )}€`}</td>
                      <td className="col">
                        {isValidDurationCdr(s, "seconds")
                          ? "-"
                          : `${roundToDecimals(s.totalPrice?.excl_vat, 2)}€`}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      });
    } else if (this.props.groupBy === "fleet") {
      return this.props.data.totalsGroupBy.map((kpi) => {
        return (
          <div className="kpi-table-container">
            <div key={kpi.name} className="group-kpis">
              <p>
                <Translate value={`report_${this.props.groupBy}`} />
                <span>{kpi.name}</span>
              </p>
              <div className="kpis-container">
                <div className="kpi">
                  <img src={battery} alt="" />
                  <Translate value="report_sessions" />
                  <p>{kpi.totalSessions}</p>
                </div>
                <div className="kpi">
                  <img src={co2} alt="" />
                  <Translate value="report_co2Saved" />
                  <p>
                    {kpi.totalCO2Saved !== undefined &&
                    !Number.isNaN(kpi.totalCO2Saved)
                      ? roundToDecimals(kpi.totalCO2Saved, 3)
                      : "-"}
                    g
                  </p>
                </div>
                <div className="kpi">
                  <img src={energy} alt="" />
                  <Translate value="report_energy" />
                  <p>
                    {kpi.totalPower !== undefined &&
                    !Number.isNaN(kpi.totalPower)
                      ? roundToDecimals(kpi.totalPower / 1000, 3)
                      : "-"}
                    kWh
                  </p>
                </div>
                <div className="kpi">
                  <img src={clock} alt="" />
                  <Translate value="report_chargingTime" />
                  <p>
                    {moment
                      .duration(kpi.timeCharged, "seconds")
                      .format("h[h] m[m] s[s]")}
                  </p>
                </div>
                <div className="kpi">
                  <img src={money} alt="" />
                  <Translate value="report_costNoVat" />
                  <p>{roundToDecimals(kpi.totalPriceExclVat, 2)} €</p>
                </div>
              </div>
            </div>
            <table className="table table-sm">
              <thead className="table-header">
                <tr className="row no-gutters">
                  <th className="col title">
                    <Translate value="report_date" />
                  </th>
                  <th className="col title">
                    <Translate value="report_duration" />
                  </th>
                  <th className="col title">
                    <Translate value="report_EV" />
                  </th>
                  <th className="col title">
                    <Translate value="report_charger" />
                  </th>
                  <th className="col title">
                    <Translate value="report_energy" />
                  </th>
                  <th className="col title">
                    <Translate value="report_user" />
                  </th>
                  <th className="col title">
                    <Translate value="report_network" />
                  </th>
                  <th className="col title">
                    <Translate value="report_location" />
                  </th>
                  <th className="col title">
                    <Translate value="report_costNoVat" />
                  </th>
                </tr>
              </thead>
              <tbody className="table-values">
                {kpi.list.map((s) => {
                  return (
                    <tr className="row no-gutters">
                      <td className="col">
                        {formatDate(s.startDate, "datetime")}
                      </td>
                      <td className="col">
                        {isValidDurationCdr(s, "seconds")
                          ? "-"
                          : moment
                              .duration(s.timeCharged, "seconds")
                              .format("h[h] m[m] s[s]")}
                      </td>
                      <td className="col">{s.ev?.licensePlate || "-"}</td>
                      <td className="col">{s.charger?.hwId || "-"}</td>
                      <td className="col">{`${roundToDecimals(
                        s.totalPower / 1000,
                        3
                      )} kWh`}</td>
                      <td className="col">{s.user?.name || "-"}</td>
                      <td className="col">{s.network || "-"}</td>
                      <td className="col">
                        {parseAddress(s.charger?.address)}
                      </td>
                      <td className="col">
                        {isValidDurationCdr(s, "seconds")
                          ? "-"
                          : `${roundToDecimals(s.totalPrice?.excl_vat, 2)}€`}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      });
    } else if (this.props.groupBy === "charger") {
      return this.props.data.totalsGroupBy.map((kpi) => {
        return (
          <div className="kpi-table-container">
            <div key={kpi.name} className="group-kpis">
              <div className="kpis-header">
                <p>
                  <Translate value={`report_${this.props.groupBy}`} />
                  <span>{kpi.name}</span>
                </p>
                <p>
                  <Translate value="report_location" />
                  <span>{parseAddress(kpi.address)}</span>
                </p>
              </div>
              <div className="kpis-container">
                <div className="kpi">
                  <img src={battery} alt="" />
                  <Translate value="report_sessions" />
                  <p>{kpi.totalSessions}</p>
                </div>
                <div className="kpi">
                  <img src={co2} alt="" />
                  <Translate value="report_co2Saved" />
                  <p>
                    {kpi.totalCO2Saved !== undefined &&
                    !Number.isNaN(kpi.totalCO2Saved)
                      ? roundToDecimals(kpi.totalCO2Saved, 3)
                      : "-"}
                    g
                  </p>
                </div>
                <div className="kpi">
                  <img src={energy} alt="" />
                  <Translate value="report_energy" />
                  <p>
                    {kpi.totalPower !== undefined &&
                    !Number.isNaN(kpi.totalPower)
                      ? roundToDecimals(kpi.totalPower / 1000, 3)
                      : "-"}
                    kWh
                  </p>
                </div>
                <div className="kpi">
                  <img src={clock} alt="" />
                  <Translate value="report_chargingTime" />
                  <p>
                    {moment
                      .duration(kpi.timeCharged, "seconds")
                      .format("h[h] m[m] s[s]")}
                  </p>
                </div>
                <div className="kpi">
                  <img src={money} alt="" />
                  <Translate value="report_costNoVat" />
                  <p>
                    {roundToDecimals(kpi.purchaseTariffDetailsExclVat, 2)} €
                  </p>
                </div>
                <div className="kpi">
                  <img src={money} alt="" />
                  <Translate value="report_revenueNoVat" />
                  <p>{roundToDecimals(kpi.totalPriceExclVat, 2)} €</p>
                </div>
              </div>
            </div>
            <table className="table table-sm">
              <thead className="table-header">
                <tr className="row no-gutters">
                  <th className="col title">
                    <Translate value="report_date" />
                  </th>
                  <th className="col title">
                    <Translate value="report_duration" />
                  </th>
                  <th className="col title">
                    <Translate value="report_charger" />
                  </th>
                  <th className="col title">
                    <Translate value="report_energy" />
                  </th>
                  <th className="col title">
                    <Translate value="report_ev" />
                  </th>
                  <th className="col title">
                    <Translate value="report_user" />
                  </th>
                  <th className="col title">
                    <Translate value="report_network" />
                  </th>
                  <th className="col title">
                    <Translate value="report_costNoVat" />
                  </th>
                  <th className="col title">
                    <Translate value="report_revenueNoVat" />
                  </th>
                </tr>
              </thead>
              <tbody className="table-values">
                {kpi.list.map((s) => {
                  return (
                    <tr key={s.startDate} className="row no-gutters">
                      <td className="col">
                        {formatDate(s.startDate, "datetime")}
                      </td>
                      <td className="col">
                        {moment
                          .duration(s.timeCharged, "seconds")
                          .format("h[h] m[m] s[s]")}
                      </td>
                      <td className="col">{s.charger?.hwId || "-"}</td>
                      <td className="col">{`${roundToDecimals(
                        s.totalPower / 1000,
                        3
                      )} kWh`}</td>
                      <td className="col">
                        {typeof s.ev === "object" ? (
                          s.ev?.licensePlate ?? "-"
                        ) : (
                          <Translate value="report_other" />
                        )}
                      </td>
                      <td className="col">
                        {typeof s.user === "object" ? (
                          s.user?.name ?? "-"
                        ) : (
                          <Translate value="report_public" />
                        )}
                      </td>
                      <td className="col">{s.network || "-"}</td>
                      <td className="col">{`${roundToDecimals(
                        s.purchaseTariffDetails?.excl_vat,
                        2
                      )}€`}</td>
                      <td className="col">{`${roundToDecimals(
                        s.totalPrice?.excl_vat,
                        2
                      )}€`}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      });
    } else if (this.props.groupBy === "ev_history") {
      const isValidValue = (value) => value && value !== "-1" && value !== "-";

      return (
        <div className="kpi-table-container landscape">
          <table className="table table-sm">
            <thead className="table-header">
              <tr className="row no-gutters">
                <th className="col title">
                  <Translate value="report_network" />
                </th>
                <th className="col title">
                  <Translate value="report_fleet" />
                </th>
                <th className="col title">
                  <Translate value="report_ev" />
                </th>
                <th className="col title">
                  <Translate value="report_group" />
                </th>
                <th className="col title">
                  <Translate value="report_user" />
                </th>
                <th className="col title">
                  <Translate value="report_charger" />
                </th>
                <th className="col title">
                  <Translate value="report_city" />
                </th>
                <th className="col title">
                  <Translate value="report_startDate" />
                </th>
                <th className="col title">
                  <Translate value="report_stopDate" />
                </th>
                <th className="col title">
                  <Translate value="report_durationInMin" />
                </th>
                <th className="col title">
                  <Translate value="report_energyInKWh" />
                </th>
                <th className="col title">
                  <Translate value="report_co2" />
                </th>
                <th className="col title">
                  <Translate value="report_durationAfterCharge" />
                </th>
                <th className="col title">
                  <Translate value="report_timeChargedInMin" />
                </th>
                <th className="col title">
                  <Translate value="report_timeCost" />
                </th>
                <th className="col title">
                  <Translate value="report_energyCost" />
                </th>
                <th className="col title">
                  <Translate value="report_activationFee" />
                </th>
                <th className="col title">
                  <Translate value="report_tariffEnergy" />
                </th>
                <th className="col title">
                  <Translate value="report_tariffTime" />
                </th>
                <th className="col title">
                  <Translate value="report_parkingDuringCharge" />
                </th>
                <th className="col title">
                  <Translate value="report_parkingTariff" />
                </th>
                <th className="col title">
                  <Translate value="report_mobieCemeTariff" />
                </th>
                <th className="col title">
                  <Translate value="report_mobieCemeTotal" />
                </th>
                <th className="col title">
                  <Translate value="report_mobieTarTotal" />
                </th>
                <th className="col title">
                  <Translate value="report_mobieOpcTotal" />
                </th>
                <th className="col title">
                  <Translate value="report_mobieSupportEM" />
                </th>
                <th className="col title">
                  <Translate value="report_mobieEgmeTariff" />
                </th>
                <th className="col title">
                  <Translate value="report_mobieIecTotal" />
                </th>
                <th className="col title">
                  <Translate value="report_totalExclVat" />
                </th>
                <th className="col title">
                  <Translate value="report_vatRate" />
                </th>
                <th className="col title">
                  <Translate value="report_totalInclVat" />
                </th>
              </tr>
            </thead>
            <tbody className="table-values">
              {this.props.data.data.map((s) => {
                return (
                  <tr key={s.startDate} className="row no-gutters">
                    <td className="col">
                      {s.network !== "history_internalNetwork" ? (
                        isValidValue(s.network) ? (
                          s.network
                        ) : isValidValue(s.charger?.network) ? (
                          s.charger.network
                        ) : (
                          "-"
                        )
                      ) : (
                        <Translate value="history_internalNetwork" />
                      )}
                    </td>
                    <td className="col">
                      {(isValidValue(s.fleet?.name) && s.fleet.name) || "-"}
                    </td>
                    <td className="col">
                      {(isValidValue(s.evId) &&
                        isValidValue(s.ev?.licensePlate) &&
                        s.ev.licensePlate) ||
                        "-"}
                    </td>
                    <td className="col">
                      {s.groupDrivers ? (
                        s.groupDrivers.name || "-"
                      ) : (
                        <Translate value="history_other" />
                      )}
                    </td>
                    <td className="col">
                      {typeof s.user === "object" ? (
                        s.user?.name ?? "-"
                      ) : (
                        <Translate value="history_other" />
                      )}
                    </td>
                    <td className="col">{s.hwId || "-"}</td>
                    <td className="col">
                      {(isValidValue(s.charger?.address?.city) &&
                        parseAddress(s.charger.address.city)) ||
                        "-"}
                    </td>
                    <td className="col">
                      {formatDate(moment(s.startDate), "datetime")}
                    </td>
                    <td className="col">
                      {formatDate(moment(s.stopDate), "datetime")}
                    </td>
                    <td className="col">
                      {(isValidValue(s.totalTimeInMin) &&
                        moment
                          .duration(s.totalTimeInMin, "minutes")
                          .format("h[h] m[m] s[s]")) ||
                        0}
                    </td>
                    <td className="col">
                      {roundToDecimals(s.totalPower, 2) || 0}
                    </td>
                    <td className="col">
                      {roundToDecimals(s.CO2Saved, 2) || 0}
                    </td>
                    <td className="col">
                      {moment
                        .duration(s.timeAfterChargedInMin, "minutes")
                        .format("h[h] m[m] s[s]") || "-"}
                    </td>
                    <td className="col">
                      {moment
                        .duration(s.timeChargedInMin, "minutes")
                        .format("h[h] m[m] s[s]") || 0}
                    </td>
                    <td className="col">
                      {roundToDecimals(s.timeCost, 2) || "-"}
                    </td>
                    <td className="col">
                      {roundToDecimals(s.energyCost, 2) || "-"}
                    </td>
                    <td className="col">
                      {roundToDecimals(s.activationFee, 2) || "-"}
                    </td>
                    <td className="col">
                      {roundToDecimals(s.tariffkWh, 2) || "-"}
                    </td>
                    <td className="col">
                      {roundToDecimals(s.tariffMin, 2) || "-"}
                    </td>
                    <td className="col">
                      {roundToDecimals(s.parkingDuringChargingAmount, 2) || "-"}
                    </td>
                    <td className="col">
                      {roundToDecimals(s.parkingAmount, 2) || "-"}
                    </td>
                    <td className="col">{s.cemeTariff || "-"}</td>
                    <td className="col">
                      {roundToDecimals(s.tariffsDetails?.ceme?.total, 2) || "-"}
                    </td>
                    <td className="col">
                      {roundToDecimals(s.tariffsDetails?.fees?.tar, 2) || "-"}
                    </td>
                    <td className="col">
                      {roundToDecimals(s.tariffsDetails?.opc?.total, 2) || "-"}
                    </td>
                    <td className="col">{s.supportElectricMobility || "-"}</td>
                    <td className="col">{s.egmeTariff || "-"}</td>
                    <td className="col">
                      {roundToDecimals(s.tariffsDetails?.fees?.iec, 2) || "-"}
                    </td>
                    <td className="col">
                      {roundToDecimals(s.totalPrice?.excl_vat, 2) || 0}
                    </td>
                    <td className="col">{s.vatRate || "-"}</td>
                    <td className="col">
                      {roundToDecimals(s.totalPrice?.incl_vat, 2) || 0}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    } else if (this.props.groupBy === "charger_history") {
      return (
        <div className="kpi-table-container">
          <table className="table table-sm">
            <thead className="table-header">
              <tr className="row no-gutters">
                <th className="col title">
                  <Translate value="report_date" />
                </th>
                <th className="col title">
                  <Translate value="report_address" />
                </th>
                <th className="col title">
                  <Translate value="report_charger" />
                </th>
                <th className="col title">
                  <Translate value="report_cpe" />
                </th>
                <th className="col title">
                  <Translate value="report_duration" />
                </th>
                <th className="col title">
                  <Translate value="report_energy" />
                </th>
                <th className="col title">
                  <Translate value="report_fleet" />
                </th>
                <th className="col title">
                  <Translate value="report_ev" />
                </th>
                <th className="col title">
                  <Translate value="report_user" />
                </th>
                <th className="col title">
                  <Translate value="report_network" />
                </th>
                <th className="col title">
                  <Translate
                    value={`report_cost${this.props.withVat ? "Vat" : "NoVat"}`}
                  />
                </th>
                <th className="col title">
                  <Translate
                    value={`report_revenue${
                      this.props.withVat ? "Vat" : "NoVat"
                    }`}
                  />
                </th>
              </tr>
            </thead>
            <tbody className="table-values">
              {this.props.data.data.map((s) => {
                return (
                  <tr key={s.startDate} className="row no-gutters">
                    <td className="col">
                      {formatDate(s.startDate, "datetime")}
                    </td>
                    <td className="col">
                      {parseAddress(s.charger?.address) || "-"}
                    </td>
                    <td className="col">{s.charger?.name || "-"}</td>
                    <td className="col">-</td>
                    <td className="col">
                      {moment
                        .duration(s.timeCharged, "hours")
                        .format("h[h] m[m] s[s]")}
                    </td>
                    <td className="col">{`${roundToDecimals(
                      s.totalPower,
                      3
                    )} kWh`}</td>
                    <td className="col">{s.fleet?.name || "-"}</td>
                    <td className="col">{s.ev?.licensePlate || "-"}</td>
                    <td className="col">{s.user?.name || "-"}</td>
                    <td className="col">{s.charger?.network || "-"}</td>
                    <td className="col">{`${roundToDecimals(
                      s.purchaseTariffDetails?.[
                        this.props.withVat ? "incl_vat" : "excl_vat"
                      ],
                      2
                    )}€`}</td>
                    <td className="col">{`${roundToDecimals(
                      s.totalPrice?.[
                        this.props.withVat ? "incl_vat" : "excl_vat"
                      ],
                      2
                    )}€`}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    }
  }

  render() {
    if (this.props.hasOwnProperty("data") && this.props.data !== null) {
      const home =
        this.props.data.accountData.hasOwnProperty("places") &&
        Array.isArray(this.props.data.accountData.places) &&
        this.props.data.accountData.places.find((p) => p.name === "home");
      const address = home ? parseAddress(home.address).split(",") : "";

      return (
        <div id="report">
          <div className="letter-face">
            <img src={this.props.data.brand?.icons?.logo ?? evio} alt="" />
            <div className="sender-info">
              {this.props.data.brand?.additionalInformation?.address && (
                <p>{this.props.data.brand.additionalInformation.address}</p>
              )}
              {this.props.data.brand?.additionalInformation?.city && (
                <p>{this.props.data.brand.additionalInformation.city}</p>
              )}
              {this.props.data.brand?.additionalInformation?.mobile && (
                <p>{this.props.data.brand.additionalInformation.mobile}</p>
              )}
              {this.props.data.brand?.additionalInformation?.email && (
                <p>{this.props.data.brand.additionalInformation.email}</p>
              )}
            </div>
            <div className="recipient-info">
              <p>{this.props.data.accountData.name}</p>
              <p>
                {Array.isArray(address) && address.length > 0
                  ? address.shift().trim()
                  : ""}
              </p>
              <p>
                {Array.isArray(address) && address.length > 0
                  ? address.reduce((a, b) => a + b).trim()
                  : ""}
              </p>
            </div>
          </div>
          <div className="report-body">
            <div className="header">
              {this.renderTitle()}
              <div className="time-period">
                <img src={calendar} alt="" />
                <Translate value="report_timePeriod" />
                <span className="period">
                  {this.props.month ||
                    `${formatDate(
                      this.props.timePeriod.from,
                      "date"
                    )} - ${formatDate(this.props.timePeriod.to, "date")}`}
                </span>
              </div>
            </div>
            <div className="total-kpis">
              <p>
                <Translate value="report_total" />
              </p>
              <div className="kpis-container">{this.renderTotalKPIs()}</div>
            </div>
            {!["ev_history", "charger_history"].includes(this.props.groupBy) &&
              this.renderGroupKPIs()}
          </div>
          {!["ev_history", "charger_history"].includes(this.props.groupBy) && (
            <div className="page-break"></div>
          )}
          <div className="report-body">{this.renderTableKPIs()}</div>
        </div>
      );
    } else return null;
  }
}

export default Report;
